import React from 'react';

import {
  SlackBot,
  TrafficCone,
  YogoCat,
  YogoCatRestart,
  YogoCatLoading,
  HandPencil,
  Author,
  Email,
} from './parts';

export type IllustName = (typeof IllustNames)[number];

const IllustNames = [
  'yogo_cat',
  'yogo_cat_loading',
  'yogo_cat_restart',
  'slack_bot',
  'traffic_cone',
  'hand_pencil',
  'author',
  'email',
] as const;

const illustMap = new Map<IllustName, React.JSX.Element>([
  ['yogo_cat', <YogoCat key="yogo_cat" />],
  ['yogo_cat_loading', <YogoCatLoading key="yogo_cat_loading" />],
  ['yogo_cat_restart', <YogoCatRestart key="yogo_cat_restart" />],
  ['slack_bot', <SlackBot key="slack_bot" />],
  ['traffic_cone', <TrafficCone key="traffic_cone" />],
  ['hand_pencil', <HandPencil key="hand_pencil" />],
  ['author', <Author key="author" />],
  ['email', <Email key="email" />],
]);

export { illustMap };
